/* Registers the Sportly PWA service worker.
 * - Only registers in production builds (avoids dev-server caching headaches)
 * - Shows a small toast when a new version is ready so users can refresh
 */
import { toast } from "sonner";

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Don't register on localhost dev unless PWA_DEV is explicitly enabled
  const isProd = process.env.NODE_ENV === "production";
  if (!isProd && process.env.REACT_APP_PWA_DEV !== "1") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // Detect updates
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New version available
              toast.success("Nieuwe versie beschikbaar — herlaad de pagina", {
                action: {
                  label: "Herlaad",
                  onClick: () => {
                    installing.postMessage({ type: "SKIP_WAITING" });
                    window.location.reload();
                  },
                },
                duration: 10000,
              });
            }
          });
        });
      })
      .catch(() => {
        /* silent — SW registration failure shouldn't break the app */
      });
  });
}
